export default __webpack_public_path__ + "static/media/style.module.fe1ddeb9.less";